// med-users requires phone numbers in E.164 (^\+[1-9]\d{1,14}$). The GLP flows are
// US-only and the shipping form collects a *national* number ("(412) 413-1241"), so the
// US country code must be added — blindly prefixing `+` yields a wrong country code
// (+41…) that passes the regex but is a garbage number. Matches the +1 (US) convention.
// Explicit international (+) input is trusted as-is; anything implausible returns null so
// callers omit the field rather than store junk.
// (If the funnel ever serves non-US markets, switch to libphonenumber-js / a dial-code map.)
export function toE164(raw: unknown): string | null {
	if (!raw) return null
	const trimmed = String(raw).trim()
	const digits = trimmed.replace(/\D/g, '')
	if (!digits) return null

	if (trimmed.startsWith('+')) {
		// Explicit international number — trust the caller's country code, just validate.
		const intl = `+${digits}`
		return /^\+[1-9]\d{1,14}$/.test(intl) ? intl : null
	}

	// National input → assume US (+1). A 10-digit number gets the country code; an
	// 11-digit value already starting with 1 already has it.
	const us = digits.length === 10 ? `+1${digits}` : `+${digits}`
	return /^\+1\d{10}$/.test(us) ? us : null
}
